import { Card, FormLayout, Layout, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import HeadingHelper from "../../helpers/HeadingHelper";
import Switch from "react-switch/index";
import React from "react";

const SRGeneralInformation = props => {
  const {
    validatorClass,
    productTypeVirtual, productTypePhysical, productTypeServices,
    withdrawalPeriod, maximumDirectCostsForReturns,
    handleChange,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t('shipping.annotate.title.product')}
      description={CsI18n.t('shipping.annotate.desc.product')}>
      <Layout.Section>
        <Card sectioned>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <FormLayout.Group condensed>
                <div>
                  <p>{HeadingHelper.ltt('Virtual Product', 'shipping.explain.virtual_product')}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('productTypeVirtual')}
                    checked={productTypeVirtual}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t('Virtual Product')}
                  />
                </div>
                <div>
                  <p>{HeadingHelper.ltt('Physical Product', 'shipping.explain.physical_product')}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('productTypePhysical')}
                    checked={productTypePhysical}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t('Physical Product')}
                  />
                </div>
                <div>
                  <p>{HeadingHelper.ltt('Services', 'shipping.explain.service_product')}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('productTypeServices')}
                    checked={productTypeServices}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t('Services')}
                  />
                </div>
              </FormLayout.Group>

              <FormLayout.Group condensed>
                <div className="input-small">
                  <V>
                    <TextField
                      label={HeadingHelper.ltt('Withdrawal period (min 14 days)', 'shipping.explain.withdrawal_period')}
                      type="number" suffix={CsI18n.t('days')} min={14}
                      onChange={handleChange("withdrawalPeriod")}
                      value={withdrawalPeriod}
                      placeholder={CsI18n.t('Ex: min 14 days')}
                    />
                    <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                    <V.Item rule="number" title={CsI18n.t("Number only.")} />
                    <V.Item rule="min" min={14} title={CsI18n.t("Too low number.")} />
                  </V>
                </div>
                <div className="input-small">
                  <V>
                    <TextField
                      label={HeadingHelper.ltt('Maximum direct costs for returns (Euro)', 'shipping.explain.maximum_direct_costs_for_returns')}
                      type="number" prefix="€" min={1}
                      onChange={handleChange("maximumDirectCostsForReturns")}
                      value={maximumDirectCostsForReturns}
                      placeholder={CsI18n.t('Euro')}
                    />
                    <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                    <V.Item rule="float" title={CsI18n.t("Not a float number.")} />
                    <V.Item rule="min" min={1} title={CsI18n.t("Too low number.")} />
                  </V>
                </div>
              </FormLayout.Group>
            </FormLayout>
          </CsValidationForm>
        </Card>
      </Layout.Section>
    </Layout.AnnotatedSection>
  )
};

export default SRGeneralInformation;